// extracted by mini-css-extract-plugin
export default {"error404page":"PageNotFound_error404page__GXq74","errorCard":"PageNotFound_errorCard__PxFfw","errorbtn":"PageNotFound_errorbtn__J61X7"};